export class ModelMetadata {
  public static readonly MODEL_MAPPING = 'model';

  static setPropertyMeta(target: any, key: any, value: string) {
    let metadata = target[ModelMetadata.MODEL_MAPPING] || {};
    metadata = {...metadata};
    metadata[key] = value;
    target[ModelMetadata.MODEL_MAPPING] = metadata;
  }


  static getProperties(target: any, attrName, defaultAttrValue): string {
    const metadata = target[ModelMetadata.MODEL_MAPPING] || {};
    const value = metadata[attrName] as string;
    return value ? value : defaultAttrValue;
  }


}
